interface IProps {
  src: string;
  alt: string;
  style?: React.CSSProperties;
  class?: string;
}

export default function BaseImage(props: IProps) {
  return (
    <img
      className={props.class}
      src={props.src || ''}
      alt={props.alt}
      style={{ width: '100%', ...props.style }}
      loading="eager"
    />
  );
}
